export default "__VITE_ASSET__e11ac050__"